import React, { Component } from "react";
import { Edit } from "admin-on-rest";
import { EditMarketersForm } from "./EditMarketersForm";
import IconTitle from "../../components/icon_title";
class MainEdit extends Component {
  render() {
    return (
      <Edit
        {...this.props}
        title={
          <IconTitle icon="marketers" title={"resources.marketers.title"} />
        }
      >
        {(permissions) => (
          // <MarketersEditForm {...props} redirect="show" permissions={permissions} />
          <EditMarketersForm
            {...this.props}
            redirect="show"
            permissions={permissions}
          />
        )}
      </Edit>
    );
  }
}

export default MainEdit;



// WEBPACK FOOTER //
// ./src/marketers/form/MainEdit.js